import TC from '../../TC';
import Consts from '../Consts';
import Scale from './Scale';

TC.control = TC.control || {};
TC.Consts = Consts;
TC.control.Scale = Scale;

TC.control.ScaleSelector = function () {
    var self = this;

    TC.control.Scale.apply(self, arguments);

    self.scales = null;
};

TC.inherit(TC.control.ScaleSelector, TC.control.Scale);

(function () {
    var ctlProto = TC.control.ScaleSelector.prototype;

    ctlProto.CLASS = 'tc-ctl-ss';

    ctlProto.template = {"1":function(container,depth0,helpers,partials,data) {    var stack1, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return "    <option value=\""    + alias1(container.lambda(depth0, depth0))    + "\""    + ((stack1 = lookupProperty(helpers,"if").call(alias2,lookupProperty(helpers,"eq").call(alias2,depth0,(depth0 != null ? lookupProperty(depth0,"scale") : depth0),{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":3,"column":31},"end":{"line":3,"column":43}}}),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":25},"end":{"line":3,"column":68}}})) != null ? stack1 : "")    + ">1:"    + alias1(lookupProperty(helpers,"round").call(alias2,depth0,{"name":"round","hash":{},"data":data,"loc":{"start":{"line":3,"column":71},"end":{"line":3,"column":82}}}))    + "</option>\r\n";},"2":function(container,depth0,helpers,partials,data) {    return " selected=\"true\"";},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return "<div class=\"ol-scale-line ol-unselectable\"><nobr><select>\r\n"    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"scales") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":4,"column":9}}})) != null ? stack1 : "")    + "</select> <input type=\"button\" value=\""    + alias2(container.lambda((depth0 != null ? lookupProperty(depth0,"screenSize") : depth0), depth0))    + "''\" title=\""    + alias2(lookupProperty(helpers,"i18n").call(alias1,"estimatedMapSize",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":5,"column":63},"end":{"line":5,"column":90}}}))    + "\" /></nobr></div>";},"useData":true}

    ctlProto.render = function (callback) {
        var self = this;
        return self._set1stRenderPromise(new Promise(function (resolve, reject) {
            if (self.map) {
                if (!self.scales && self.map.options.resolutions) {
                    self.scales = self.map.options.resolutions.map(self.getScale, self);
                }
                var render = function () {
                    self.scales = self.map.wrap.getResolutions().map(self.getScale, self);
                    self.renderData({ scale: self.getScale(), screenSize: TC.Cfg.screenSize, scales: self.scales }, function () {

                        self.div.querySelectorAll('option').forEach(function (option) {
                            option.textContent = '1:' + self.format(option.textContent.substr(2));
                        });

                        self.div.querySelector('input[type="button"]').addEventListener(TC.Consts.event.CLICK, function () {
                            self.setScreenSize();
                        }, { passive: true });

                        self.div.querySelector('select').addEventListener('change', function () {
                            self.setScale(this.value);
                        });
                        if (TC.Util.isFunction(callback)) {
                            callback();
                        }
                        resolve();
                    }).catch(function (err) {
                        reject(err instanceof Error ? err : Error(err));
                    });
                };
                if (self.scales) {
                    render();
                }
                else {
                    self.map.wrap.getMap().then(render);
                }
            }
            else {
                reject(Error('ScaleSelector no registrado'));
            }
        }));
    };

    /*
    *  setScale: Sets the resolution of the map from a scale denominator and estimated screen DPI
    *  Parameters: number, the scale denominator
    *  Returns: number, the resolution
    */
    ctlProto.setScale = function (scale) {
        var self = this;
        var result = scale * .0254 / self.getDpi(TC.Cfg.screenSize);
        if (window.devicePixelRatio) {
            result = result / window.devicePixelRatio;
        }
        if (self.metersPerDegree) {
            result = result / self.metersPerDegree;
        }
        self.map.wrap.setResolution(result);
        return result;
    };

})();

const ScaleSelector = TC.control.ScaleSelector;
export default ScaleSelector;